<!--
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 14:02:22
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2025-10-23 16:43:51
-->
<template>
    <div :class="['setting-user', $i18n.locale]">
        <div class="header-menu">
            <span>
                <img
                    src="@/assets/images/sidebar/arrow-left.png"
                    alt
                    class="menu-info"
                    @click="onClickLeft"
                />
            </span>
        </div> 
        <div class="content">
            <div class="title">{{ $t('login.accountSecurity.bindFailure') }}</div>
            <div class="tips">
                {{tips}}
            </div>
            <div class="content-view "> 
                <div class="phone">
                   {{account}}  
                </div>
            </div>

            <div class="button" @click="onClickLeft">
                {{$t('login.accountSecurity.returnButton')}}
            </div>
        </div>  
    </div>
</template>

<script> 

export default {
    data() {
        return {  
            iphone:'',
            mobile: '', 
            tips: '',
            account: '',
        }
    },
    created() {
        console.log(this.$route.query)
        let name = ""
        if(this.$route.query.type == 1){
            name = "Google"
        }else if(this.$route.query.type == 2){
            name = "Facebook"
        } 
        this.tips = this.$t('login.accountSecurity.bindFailureTips', {item: name})
        if(this.$route.query.email) {
            this.account =  this.encryptEmail(this.$route.query.email)
        }

        if(this.$route.query.phone) {
            this.account = this.fomatterIphone(this.$route.query.phone)
        }

    },
    computed: { 
    },
    mounted() { 
       
    },
    methods: { 
        fomatterIphone(str) {
            // const reg = /(\d{3})\d*(\d{4})/
            // const result = str.replace(reg, '$1****$2')
            // return result
            let result = str || ''
            const phoneLen = result.length
            if (phoneLen > 14) {
                result = result.substr(0, 7) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen === 14) {
                result = result.substr(0, 6) + '****' + result.substr(phoneLen - 4)
            } else if (phoneLen > 7) {
                result = result.substr(0, 5) + '*'.repeat(phoneLen - 7) + result.substr(phoneLen - 2)
            }
            return result
        },
       encryptEmail(email) {
            // 检查是否是合法邮箱格式
            if (!email || typeof email !== 'string' || !email.includes('@')) {
                return email || '';
            } 
            // 分割用户名和域名
            const [username, domain] = email.split('@');
            const len = username.length; 
            // 处理用户名部分
            let encryptedUsername;
            
            if (len <= 4) {
                // 长度≤4：只加密最后一位
                encryptedUsername = username.slice(0, -1) + '*';
            } else {
                // 长度>4：加密第4到第6位（如果存在）
                const firstPart = username.slice(0, 3); // 保留前3位
                let middlePart = username.slice(3, 6);  // 要加密的部分（第4-6位）
                const lastPart = username.slice(6);     // 第6位之后的部分
                
                // 加密中间部分（每个字符替换为*）
                middlePart = middlePart.replace(/./g, '*');
                
                encryptedUsername = firstPart + middlePart + lastPart;
            } 
            return encryptedUsername + '@' + domain;
        },
        onClickLeft() {
            //
            this.$router.push({
                path: '/accountSecurity',
            });
        }
        
    },
}
</script>

<style lang="less" scoped>
.setting-user {
    width: 100%;
    height: 100%;
    background-color: #222341;
    text-align: left;
    overflow: scroll;
   
    .header-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 15px;
        width: 100%;
        top: 0;
        z-index: 100;
        > span {
            img {
                display: block;
            }
        }
        .menu-info {
            width: 24px;
            height: 24px;
        }
    } 
    .content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 15px;
        .title {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center; 
            padding-top: 10px;
            font-size: 22px; 
            color: #fff;
        }
        .tips {
            width: 100%;
            padding:0 10px 0 10px;
            font-size: 12px; 
            color: rgba(255, 255, 255, 0.5);
            margin-top: 80px;
        }
        .content-view {
           display: flex;
           justify-content: center;
           align-items: center;
           background-color: #303C5C; 
           width: 100%;
           border-radius: 4px; 
           min-height: 70px;
           margin-top: 16px; 

           .phone {
             color: #fff;
             font-size: 16px;
           }
        }

         .button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 40px;
            margin-top: 160px;
            outline: none;
            border-radius: 6px;
            background-image: -webkit-gradient(linear, left top, right top, from(#00e3c9), to(#009fe8));
            background-image: -webkit-linear-gradient(left, #00e3c9, #009fe8);
            background-image: -o-linear-gradient(left, #00e3c9, #009fe8);
            background-image: linear-gradient(to right, #00e3c9, #009fe8);
            font-size: 16px;
            color: #222222;
        }
        

    }  
   
}

    .ar-AR {  
        .header-menu{
            span .menu-info{
                position: relative;
                left: 320px;
            }
        }
        .content {
          direction: rtl;
        }
    }
 
 
</style> 
